import * as React from "react";

interface HeadingsProps {
  text?: string;
  type?: string;
  classes?: string;
  link?: string;
  linkClasses?: string;
}

export const Headings = ({ text = "", type = "h1", classes = "", link, linkClasses }: HeadingsProps) => {
  const validHeadingTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
  const safeType = validHeadingTags.includes(type) ? type : 'h1';
  const CustomTag = safeType as keyof JSX.IntrinsicElements;

  const allClasses = classes ? `text__heading ${classes}` : `text__heading ${safeType}`;
  const finalClasses = allClasses.trim();

  if (link) {
    return (
      <CustomTag className={finalClasses}>
        <a href={link} className={linkClasses}>
          {text}
        </a>
      </CustomTag>
    );
  }

  return <CustomTag className={finalClasses}>{text}</CustomTag>;
};
